export default "__VITE_ASSET__Bhsn8$Au__"